import Vue from 'vue';
export default {
  methods: {
    tranformMissionConfirmation: function (data) {
      const tranformData = [...data]?.map(({ creationDate, latitude, longitude, user }) => {
        const { firstName, lastName, userName } = user;
        const fullName = firstName && lastName ? `${firstName} ${lastName}` : userName;
        const date = Vue.moment(creationDate).format('jYYYY/jMM/jDD-HH:mm:ss');
        let x = 12.23;
        x.toFixed;
        return {
          date,
          fullName,
          latitude: latitude ? Number(latitude)?.toFixed(6) : '',
          longitude: longitude ? Number(longitude)?.toFixed(6) : '',
        };
      });
      return tranformData;
    },
  },
};
